import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  BsFillBagCheckFill,
  BsStarFill,
  BsStarHalf,
  BsStar,
} from "react-icons/bs";
import { motion, useAnimation } from "framer-motion";

import dummy from "../../assets/images/link.png";
import Icon from "../common/Icon";
import AddToCartButton from "./AddToCartButton";

function ProductCard({ product = {} }) {
  const [added, setAdded] = useState(false);
  const controls = useAnimation();
  const navigate = useNavigate();
  const loggedInUser = JSON.parse(localStorage.getItem("loggedInUser"));
  const handleAddToCart = async (e) => {
    e.stopPropagation();
    try {
      await controls.start({
        scale: [1, 1.3, 0.9, 1.1, 1],
        rotate: [0, 180, 270, 360],
        filter: [
          "brightness(1)",
          "brightness(1.4)",
          "brightness(1.6)",
          "brightness(1.2)",
          "brightness(1)",
        ],
        transition: {
          duration: 0.8,
          ease: "easeInOut",
        },
      });
      setAdded(true);
    } catch (err) {
      console.error(err);
    }
  };

  const handleOnError = (e) => {
    e.target.src = dummy;
  };

  // ⭐ Render star rating
  const renderStars = (rating = 0) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalf = rating % 1 >= 0.5;

    for (let i = 0; i < 5; i++) {
      if (i < fullStars)
        stars.push(<BsStarFill key={i} className="text-quaternary" />);
      else if (i === fullStars && hasHalf)
        stars.push(<BsStarHalf key={i} className="text-quaternary" />);
      else stars.push(<BsStar key={i} className="text-gray" />);
    }

    return <div className="flex items-center gap-[3px] mt-1">{stars}</div>;
  };

  const isOutOfStock = product?.inStock === "0";

  return (
    <div
      className={`productCard relative bg-[#DEE2DD]/40 rounded-[15px]  hover:shadow-lg  transition-all`}

      //onClick={() => navigate(`/shop/${product._id}`)}
    >
      {/* Discount badge */}
      {product.salePrice &&
        product.price &&
        parseInt(product.salePrice) < parseInt(product.price) && (
          <div className="offDisplay absolute bg-orange left-0 top-0 px-4 py-0.5 rounded-[8px] z-[50]">
            <span className="number text-white text-sm font-mono">
              {Math.round(
                ((parseInt(product.price) - parseInt(product.salePrice)) /
                  parseInt(product.price)) *
                  100
              )}
              % off
            </span>
          </div>
        )}
      {isOutOfStock && (
        <>
          <div className="absolute top-0 z-[20] right-0 bg-secondary text-white px-3 py-1.5 text-xs rounded-[8px]  uppercase">
            Out of Stock
          </div>
        </>
      )}
      {/* Product image */}

      <div className="relative w-full rounded-t-[15px] aspect-square bg-white flex items-center justify-center overflow-hidden">
        <Link
          to={`/shop/${product.slug}`}
          title="Click to view product details"
        >
          <img
            src={
              product.image
                ? process.env.REACT_APP_BACKEND_URL + "public/" + product.image
                : dummy
            }
            alt={product.title || "Product"}
            onError={handleOnError}
            className="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
          />
        </Link>
        {/* Out of stock overlay */}
        {isOutOfStock && (
          <Link
            to={`/shop/${product.slug}`}
            title="Click to view product details"
          >
            <div className="absolute inset-0 bg-black/40 flex items-center justify-center z-[10]" />
          </Link>
        )}
        <Link to={`/shop/${product.slug}`}>
          <div
            className="absolute z-[21] bottom-5 right-6 text-orange hover:text-secondary"
            title="Click to view product details"
          >
            <Icon icon="plus" size={40} className="bg-white rounded-full" />
          </div>
        </Link>
      </div>

      {/* Plus icon */}

      {/* Details Section */}
      <div className="detailsSection px-4 py-4 relative min-h-[130px] cursor-pointer">
        {/* Product title */}
        <p
          className="text-[20px] leading-tight text-gray-800 line-clamp-2 h-[52px]"
          title={product.title}
          onClick={() => navigate(`/shop/${product.slug}`)}
        >
          {product.title}
        </p>

        {/* ⭐ Star Rating */}
        {/* {product.rating && <div>{renderStars(product.rating)}</div>} */}

        {/* Price Section */}
        <div className="mt-2 max-w-[80%]">
          {parseInt(product.salePrice) < parseInt(product.price) ? (
            <>
              <span className="text-orange text-[18px] ">
                {product.salePrice} AED
              </span>{" "}
              <sup className="line-through text-secondary text-[14px]">
                {product.price} AED
              </sup>
            </>
          ) : (
            <span className="text-orange text-[18px] ">
              {product.salePrice} AED
            </span>
          )}
        </div>

        {/* Add to cart button */}
        {!isOutOfStock && (
          <AddToCartButton
            isOutOfStock={product.isOutOfStock}
            onAdd={handleAddToCart}
            addedToCart={product?.addedToCart || 0}
            productId={product._id}
            customerId={loggedInUser?._id}
            variant="icon"
            customerEmail={loggedInUser?.email}
          />
        )}
      </div>
    </div>
  );
}

export default ProductCard;
